export const FAV_ADD = 'add new Fav';
export const FAV_REMOVE = 'remove Fav';
export const FAV_TOGGLE = 'toggle Fav';
export const FAV_UPDATE = 'update_Fav_List';
export const FAV_GET  = 'get Fav';
export const FAV_ADD_GROUP  = 'add new Fav Group';
export const FAV_REMOVE_GROUP  = 'remove Fav Group';
export const FAV_GET_GROUP  = 'get Fav Group';